import React, {Component} from 'react';
import '../../styles/Home.css'

export default class PotwierdzEmail extends Component {

    render() {
        return <div className="text-center ramka" style={{padding: 50, background: 'white'}}>
            <b><h2><i className="fa fa-2x fa-check" style={{color: '#8dc846'}}> </i> Rejestracja przebiegła pomyślnie
            </h2>
                <h5 style={{fontWeight: 400}}>Na podany adres e-mail został wysłany link potwierdzający
                    rejestrację.</h5></b>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/kontoComponents/PotwierdzEmail.js